import React from "react";
import { Provider } from "react-redux";
import { BrowserRouter as Router, Route } from "react-router-dom";
import { store } from "./store";
import SensorOverviewComponent from "./components/list/SensorOverview";
import SensorDetailComponent from "./components/sensor/SensorDetail";
import SensorEditComponent from "./components/sensor/SensorEdit";

type SensorsProps = {
  basePath: string;
  apiUrl: string;
};

const Sensors = ({ basePath, apiUrl }: SensorsProps) => (
  <div id="dacom-online">
    <Router>
      <Provider store={store}>
        <Route path={basePath} exact>
          <SensorOverviewComponent apiUrl={apiUrl} />
        </Route>
        <Route path={`${basePath}/:sensorId/detail`}>
          <SensorDetailComponent basePath={basePath} apiUrl={apiUrl} />
        </Route>
        <Route path={`${basePath}/:sensorId/edit`}>
          <SensorEditComponent apiUrl={apiUrl} />
        </Route>
      </Provider>
    </Router>
  </div>
);

export default Sensors;
